import { ApplicationConfig, ENV } from "./types";

// This is the actual config file that serves the app.
// The content gets replaced with the contents of the environment specific config files on app build

// (see dip-frontend/project.json)
export const config: ApplicationConfig = {
  AUTH0: { AUDIENCE: "", CLIENT_ID: "", DOMAIN: "" },
  DIP_API_BASE_URL: "",
  DISCLOSURE_SERVICE_API_BASE_URL: "",
  ENV: ENV.DEVELOPMENT,
  LAUNCH_DARKLY_CLIENT_TOKEN: "",
};
